import { cva, type VariantProps } from 'class-variance-authority'

export const spinnerVariants = cva(
  'border-primary animate-spin rounded-full border-4 border-t-transparent',
  {
    variants: {
      size: {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type SpinnerVariants = VariantProps<typeof spinnerVariants>
